module.exports = __webpack_public_path__ + "static/img/bg_2_3.e2a7be5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_3.png
// module id = KbDd
// module chunks = 3